module.exports = __webpack_public_path__ + "static/media/genralDetailsLight.621799f6.svg";